import {
  DISABLE_365_INTEGRATION_REQUEST_ASYNC,
  DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC,
  STATUS_365_REQUEST_ASYNC,
  STATUS_POWERSHELL_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    data: {},
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case STATUS_365_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case STATUS_365_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            ...action.payload.data,
            basicIntegration: !!action.payload.data.status,
          },
        }
      case STATUS_365_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case DISABLE_365_INTEGRATION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case DISABLE_365_INTEGRATION_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case STATUS_POWERSHELL_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case STATUS_POWERSHELL_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            ...action.payload.data,
            advancedIntegration: !!action.payload.data.status,
          },
        }
      case STATUS_POWERSHELL_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      default:
        return state
    }
  }
}
